import { useEffect, useState } from 'react';
import { useMediaQuery } from '../../hooks/useMediaQuery';

const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState(false);
  const matched = useMediaQuery('md');

  useEffect(() => {
    setIsMobile(matched);
    return () => {
      //DO NOTHING
    };
  }, [matched]);

  return isMobile;
};

export default useIsMobile;
